import React, { useEffect } from 'react';
import Breadcrumb from '../Breadcrumb';
import LocationInMap from '../LocationInMap';
import Section from '../Section';
import FormStyle2 from '../Form/FormStyle2';
import IconboxStyle2 from '../Iconbox/IconboxStyle2';
import SectionHeadingStyle3 from '../SectionHeading/SectionHeadingStyle3';
import { PAGE_SEO } from '../../config/seo';
import { useSEO } from '../../helpers/useSEO';

const locationData =
  'https://maps.google.com/maps?q=Les+Berges+du+lac+2,+en+face+de+clinique+hannibal,+Tunis&hl=fr&z=15&output=embed';

const addressUrl = 'https://maps.app.goo.gl/N3bjGShp3ETJwPnQ8';

export default function ContactPage() {
  useSEO(PAGE_SEO.contact);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Breadcrumb title="Contact" bgUrl="/images/about.jpg" />
      <Section pt="133" ptLg="75" pb="133" pbLg="75">
        <div className="container">
          <div className="row">
            <div className="col-xl-7 col-lg-6">
              <SectionHeadingStyle3
                sectionTitleUp="Avez-vous des questions ?"
                sectionTitle="Écrire un message"
              />
              <FormStyle2 />
            </div>
            <div className="col-xl-5 col-lg-6">
              <div className="cs_pl_60 cs_pl_lg_0 cs_pt_lg_60">
                <SectionHeadingStyle3
                  sectionTitleUp="Contactez-nous"
                  sectionTitle="Travaillons ensemble"
                  sectionSubTitle="Fournir des conseils juridiques, rédaction de contrats, assistance en conformité, protection de la propriété intellectuelle et autre soutien juridique pour les entreprises."
                  className="cs_mb_40"
                />
                <div className="cs_iconbox_wrapper cs_style1">
                  <IconboxStyle2
                    imgUrl="/images/icons/contact_icon_1.svg"
                    title="+ 216 00 000 000"
                    titleUp="Avez-vous des questions ?"
                    textColor="text-primary"
                  />
                  <IconboxStyle2
                    imgUrl="/images/icons/contact_icon_2.svg"
                    title="Nexting@support.com"
                    titleUp="Envoyer un e-mail"
                    textColor="text-primary"
                  />
                  <IconboxStyle2
                    imgUrl="/images/icons/contact_icon_3.svg"
                    title="Les Berges du lac 2 , en face de clinique hannibal"
                    titleUp="Adresse"
                    titleHref={addressUrl}
                    textColor="text-primary"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Section>
      <LocationInMap data={locationData} />
    </>
  );
}
